import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, MessageCircle, PenTool, ListChecks } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-terracotta" data-id="element-169" />,
    title: 'El Manual "Sin Relleno"',
    desc: 'Directo al grano. Lees hoy, aplicas hoy. Nada de teoría innecesaria.'
  }, {
    icon: <MessageCircle className="w-8 h-8 text-terracotta" data-id="element-170" />,
    title: 'Guiones "Anti-Conflicto"',
    desc: 'Qué decir exactamente (palabra por palabra) para desactivar una pelea antes de que empiece.'
  }, {
    icon: <PenTool className="w-8 h-8 text-terracotta" data-id="element-171" />,
    title: 'Plantillas de Acuerdo Rápido',
    desc: 'Formatos listos para rellenar en 5 minutos. Lo escribes, lo firmas, lo cumples.'
  }, {
    icon: <ListChecks className="w-8 h-8 text-terracotta" data-id="element-172" />,
    title: 'Checklist de Mantenimiento',
    desc: 'La guía rápida para sus micro-reuniones. Para que nunca se olviden de lo importante.'
  }];
  return <section className="py-24 px-4 bg-cream" data-id="element-173">
      <div className="max-w-6xl mx-auto" data-id="element-174">
        <div className="text-center mb-16" data-id="element-175">
          <h2 className="text-4xl md:text-5xl font-bold text-brown mb-4" data-id="element-176">
            Lo que recibes
          </h2>
          <p className="text-xl text-brown-light max-w-2xl mx-auto" data-id="element-177">
            No es un curso. No es un libro. Es un kit de herramientas de
            emergencia para padres.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-178">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm border border-blush/20 flex gap-6 hover:shadow-md transition-shadow" data-id="element-179">
              <div className="bg-blush/10 w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-180">
                {item.icon}
              </div>
              <div data-id="element-181">
                <h3 className="font-bold text-lg text-brown mb-2" data-id="element-182">
                  {item.title}
                </h3>
                <p className="text-brown-light leading-relaxed" data-id="element-183">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}